import { useEffect } from 'react';

import { EAppThemeMode, EAppThemeScheme, appThemeService } from '@aqx-core/common/theme';
import { appThemeViewController } from '@aqx-core/common/theme/service/controller';

const getThemeModeFromSystemPreferences = () => {
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return EAppThemeMode.DARK;
  }
  return EAppThemeMode.LIGHT;
};

export const useInitWebColorTheme = () => {
  useEffect(() => {
    appThemeViewController.init(getThemeModeFromSystemPreferences());
  }, []);

  useEffect(() => {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function (e) {
      if (appThemeService.getThemeScheme() === EAppThemeScheme.SYSTEM_SCHEME) {
        appThemeViewController.updateTheme(
          EAppThemeScheme.SYSTEM_SCHEME,
          e.matches ? EAppThemeMode.DARK : EAppThemeMode.LIGHT
        );
      }
    });
  }, []);
};
